import { baseURL } from "./_common";

export default [
  {
    // PARALLAX 1
    id: 301,
    type: "parallax",
    title: "Simple Parallax",
    template: "block-parallax1",
    hasScript: true,
    firebase: false,
    required: [
      {
        title: "parallax",
        js: "parallax.js",
        css: null
      }
    ],
    options: {
      fullHeight: false,
      parallax: { percentage: "20", speed: 0.6 },
      bg: {
        url: `${baseURL}/static/templates/theme1/img/bg/03.jpg`,
        color: "transparent"
      },
      title: {
        text: "The Fastest Way To Develop",
        color: "#ffffff"
      },
      subtitle: {
        text:
          "Lorem ipsum dolor sit amet, erat sit penatibus gravida elit, sed sagittis eleifend metus posuere eu etiam, sit porta sed, nam amet.",
        color: "rgba(255, 255, 255, 0.8)"
      },
      buttons: [
        {
          id: 1,
          href: "#",
          target: "_self",
          text: "Learn More",
          type: "primary"
        }
      ]
    },
    settings: [
      { el: "fullHeight", title: "Full Height", type: "toggle" },
      { el: "bg", title: "Background URL", type: "image" },
      {
        el: "parallax.percentage",
        title: "Parallax Top Position %",
        type: "slider",
        min: 0,
        max: 100
      },
      {
        el: "parallax.speed",
        title: "Parallax Speed",
        type: "slider",
        min: 0,
        max: 1,
        step: 0.1
      },
      { el: "bg.color", title: "Background Color", type: "color" },
      { el: "title.color", title: "Title Color", type: "color" },
      { el: "subtitle.color", title: "Subtitle Color", type: "color" },
      {
        el: "buttons",
        title: "Buttons",
        type: "array",
        children: [
          { el: "href", title: "Button href", type: "input" },
          { el: "text", title: "Button text", type: "input" },
          {
            el: "type",
            title: "Button type",
            type: "select",
            options: [
              { text: "Primary", value: "primary" },
              { text: "Secondary", value: "secondary" },
              { text: "Accent", value: "accent" }
            ]
          },
          {
            el: "target",
            title: "Button target",
            type: "select",
            options: [
              { text: "Same Window", value: "_self" },
              { text: "New Tab", value: "_blank" },
              { text: "Top Window (for iframes)", value: "_top" }
            ]
          }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/util/blockTemplatesParallax.js